import React, { useState, useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import {
  PawPrint
} from 'lucide-react';

import { motion, AnimatePresence } from 'framer-motion';

import { useUser } from "@clerk/clerk-react";
import { HealthInput } from "@/components/health-input";

// Loading Component
const LoadingSpinner = () => (
  <div className="flex flex-col items-center justify-center h-full space-y-4">
    <motion.div
      className="relative w-24 h-24"
      animate={{ rotate: 360 }}
      transition={{
        duration: 2,
        repeat: Infinity,
        ease: "linear"
      }}
    >
      <div className="absolute inset-0 rounded-full border-4 border-amber-200 border-t-amber-500" />
      <div className="absolute inset-0 flex items-center justify-center">
        <PawPrint className="w-10 h-10 text-amber-600" />
      </div>
    </motion.div>
  </div>
);

const DogAnalyzer = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { isSignedIn, isLoaded, user } = useUser();

  // State Management
  const [activeTab, setActiveTab] = useState(() => {
    const tabFromUrl = searchParams.get('tab');
    const savedTab = localStorage.getItem('dogAnalyzer.activeTab');
    return tabFromUrl || savedTab || 'new-analysis';
  });

  const [files, setFiles] = useState([]);
  const [analysis, setAnalysis] = useState(null);
  const [userContext, setUserContext] = useState('');


  useEffect(() => {
    const tabFromUrl = searchParams.get('tab');
    if (tabFromUrl && tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
      localStorage.setItem('dogAnalyzer.activeTab', tabFromUrl);
    }
  }, [searchParams, activeTab]);

  useEffect(() => {
    if (activeTab === 'new-analysis') {
      localStorage.setItem('dogAnalyzer.analysisState', JSON.stringify({
        files,
        userContext,
        lastAnalysis: analysis
      }));
    }
  }, [files, userContext, analysis, activeTab]);

  useEffect(() => {
    if (activeTab === 'new-analysis') {
      const savedState = localStorage.getItem('dogAnalyzer.analysisState');
      if (savedState) {
        const parsed = JSON.parse(savedState);
        setUserContext(parsed.userContext || '');
        setAnalysis(parsed.lastAnalysis);
        // Note: Files might need special handling
      }
    }
  }, [activeTab]);

  // Loading and Auth checks
  if (!isLoaded) {
    return (
      <div className="h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!isSignedIn) {
    return <Navigate to="/?sign-in=true" />;
  }

  return (
    <div className="min-h-[calc(100vh-64px)] px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-6xl mx-auto">
        <div className="flex flex-col space-y-6">
          <HealthInput />
        </div>
      </div>
    </div>
  );
};

export default DogAnalyzer;